import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import { FlightAndObjectActionApplyModal } from "./FlightAndObjectActionApplyModal";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

type ApplyFlightAndObjectActionListActionLocalState = AbstractActionLocalState & {
    modalOpen: boolean,
    selection: (string | number)[]
}

type ApplyFlightAndObjectActionListActionProps = AbstractActionProps & {
    initialFlightFilter?: Filter,
    foaFilter?: Filter
}

export class ApplyFlightAndObjectActionListAction extends AbstractAction<ApplyFlightAndObjectActionListActionProps, ApplyFlightAndObjectActionListActionLocalState> {

    icon = this.getIcon();
    label = _msg("FlightAndObjectAction.apply.rules.label", _msg("FlightAndObjectAction.label.plural"));
    
    protected getIcon() {
        let defaultIcon = entityDescriptors["FlightAndObjectAction"].icon as unknown as JSX.Element;
        return <defaultIcon.type key={defaultIcon.key} {...defaultIcon.props} className="AbstractAction_iconGroup" />
    }

    constructor(props: AbstractActionProps) {
        super(props);
        this.state = { modalOpen: false, selection: [] };
    }

    isVisible(param: IActionParam) {
        if (param.selection.length === 0) {
            return false;
        }
        const entityName = this.getEntityName(param.selection[0]);
        return entityName === "Flight" || entityName === "Task";
    }

    openModal(selection: any[]) {
        this.setState({ modalOpen: true, selection });
    }

    async run(param: IActionParamForRun) {
        this.openModal(param.selection);
    }

    protected getFlightId() {
        const key = this.state.selection[0];
        const entity = this.props.getEntityAt(key);
        return this.getEntityName(key) === "Flight" ? entity?.id : entity?.taskGroup.id;
    }

    render() {
        return this.state.modalOpen ? <FlightAndObjectActionApplyModal foaFilter={this.props.foaFilter || null} showModal 
            initialFlightFilter={this.props.initialFlightFilter || Filter.createComposed(FilterOperators.forComposedFilter.and, [Filter.create("id", FilterOperators.forNumber.equals, this.getFlightId())])}
            afterClose={() => {
                this.setState({ modalOpen: false, selection: [] });
                this.props.tablePage.refresh();
            }} /> : <></>
    }

}